import { Reveal, SectionHead } from "./Reveal";
import { Lightbulb, PenTool, Code2, Globe } from "lucide-react";

const STEPS = [
  [Lightbulb, "Idea"],
  [PenTool, "Design"],
  [Code2, "Development"],
  [Globe, "Live"],
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-ink py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-6 md:px-12 lg:grid-cols-2 lg:items-center">
      <div>
        <SectionHead
          eyebrow="About Falkeen"
          title="Your business deserves a professional digital presence."
        />
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-zinc-400">
            Falkeen Technologies creates modern websites for businesses that want to look professional,
            build trust and make it easier for customers to discover and contact them.
          </p>
          <p className="mt-4 text-base leading-relaxed text-zinc-400">
            We combine premium design, modern technology and practical business functionality to create
            websites that deliver real value without traditional agency-level pricing.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-8 border-l-2 border-accent pl-5 font-display text-lg font-extrabold uppercase leading-snug tracking-wide text-white md:text-xl">
            Premium digital experiences. <span className="text-gradient">Without the premium agency price.</span>
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="relative">
        <div className="glass relative rounded-2xl p-8 md:p-10">
          <div className="absolute -top-24 right-0 h-48 w-48 rounded-full bg-accent/10 blur-[80px]" />
          <div className="relative flex flex-col gap-0">
            {STEPS.map(([Icon, label], i) => (
              <div key={label} className="flex items-center gap-5">
                <div className="flex flex-col items-center">
                  <div className="glow-accent flex h-14 w-14 items-center justify-center rounded-xl border border-accent/30 bg-charcoal">
                    <Icon className="h-6 w-6 text-accent" strokeWidth={1.5} />
                  </div>
                  {i < STEPS.length - 1 && (
                    <div className="h-8 w-px bg-gradient-to-b from-accent/50 to-white/10" />
                  )}
                </div>
                <div className={i < STEPS.length - 1 ? "pb-8" : ""}>
                  <p className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-500">
                    Step 0{i + 1}
                  </p>
                  <p className="font-display text-xl font-extrabold uppercase tracking-wide text-white">
                    {label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
